(function () {
  document.documentElement.dataset.bcfHomeFlow = 'minimal';
  document.title = 'Basic Chain Factory · Four solid 925 Ropes';

  var config = window.BCFMinimalConfig || {};
  var asset = config.assetBase || '';
  var products = config.products || [
    { sku: '040', name: 'Subtle Rope', mm: '2.0mm', price: '$50', purpose: 'The quietest presence' },
    { sku: '050', name: 'Balanced Rope', mm: '2.5mm', price: '$74', purpose: 'The everyday middle' },
    { sku: '060', name: 'Present Rope', mm: '2.8mm', price: '$102', purpose: 'Noticeably there' },
    { sku: '070', name: 'Statement Rope', mm: '3.2mm', price: '$133', purpose: 'The fullest presence' }
  ];

  var cover = document.createElement('section');
  cover.className = 'minimal-home-cover';
  cover.setAttribute('aria-label', 'Basic Chain Factory introduction');
  cover.innerHTML = '<a class="minimal-home-cover__link" href="#minimal-brand"><img src="' + asset + 'bcf-higgsfield-subtle-hero-v2-1200.jpg" alt="Lifestyle visualization of a man wearing a subtle silver Rope with a white T-shirt"><span class="minimal-home-cover__copy"><small>Solid 925 for everyday wear</small><strong>Wear Real Silver.</strong><em>Meet the four everyday Ropes <b aria-hidden="true">↓</b></em></span><span class="minimal-home-cover__disclosure">Lifestyle visualization · exact products below</span></a>';

  var hero = document.createElement('section');
  hero.className = 'minimal-home-hero';
  hero.id = 'minimal-brand';
  hero.setAttribute('aria-labelledby', 'minimal-home-title');
  hero.innerHTML = '<div class="minimal-home-hero__grid"><div class="minimal-home-hero__copy"><span class="minimal-home-hero__eyebrow">Four solid 925 Ropes · Houston since 2009</span><h1 id="minimal-home-title">Real silver. Not silver-ish.</h1><p class="minimal-home-hero__lead">Four levels of presence, all made from solid 925 sterling. Choose the one that looks like you. We show the exact width, fit, listed weight and price before you buy.</p><a class="minimal-home-hero__secondary" href="#why-bcf">Why BCF</a></div><div class="minimal-home-hero__rail">' + products.map(function (item) { return '<a class="minimal-home-hero__item" href="' + item.url + '"><img src="' + asset + 'bcf-pdp-rope-' + item.sku + '-onneck-800.jpg" alt="Model wearing the ' + item.name + ' at 20 inches"><span><strong>' + item.name + '</strong><small data-price-cents="' + (item.cents || '') + '" data-compare-at-cents="' + (item.compareAtCents || '') + '">' + item.mm + ' · ' + item.price + '</small></span></a>'; }).join('') + '</div></div>';

  var main = document.getElementById('MainContent');
  if (main) {
    main.insertBefore(hero, main.firstElementChild);
    main.insertBefore(cover, hero);
  }

  var grid = document.getElementById('grid');
  if (grid) {
    grid.hidden = true;
    grid.setAttribute('aria-hidden', 'true');
  }

  var reasons = document.createElement('section');
  reasons.className = 'minimal-home-reasons';
  reasons.id = 'why-bcf';
  reasons.setAttribute('aria-labelledby', 'minimal-reasons-title');
  reasons.innerHTML = '<div class="minimal-home-reasons__grid"><figure class="minimal-home-reasons__image"><img src="' + asset + 'bcf-pdp-shared-925-hardware-editorial-final-1254.jpg" alt="Actual BCF clasp with a struck 925 sterling hallmark"></figure><div class="minimal-home-reasons__copy"><span>Why Basic Chain Factory</span><h2 id="minimal-reasons-title">The material is simple. The explanation should be too.</h2><div class="minimal-home-reasons__facts"><div class="minimal-home-reasons__fact"><b>01</b><div><strong>Solid 925, never plated</strong><p>The actual chain and clasp are sterling silver, not a silver-colored layer over base metal.</p></div></div><div class="minimal-home-reasons__fact"><b>02</b><div><strong>Specifications before checkout</strong><p>Width, length, listed gram weight and price stay together on every product page.</p></div></div><div class="minimal-home-reasons__fact"><b>03</b><div><strong>Houston jewelry operation since 2009</strong><p>BCF comes from a wholesale operation that has supplied jewelry retailers across the U.S. and Canada.</p></div></div></div></div></div>';
  var reviews = document.getElementById('customer-reviews');
  var reviewsWrap = reviews && reviews.closest('.bcf');
  if (reviewsWrap && reviewsWrap.parentNode) reviewsWrap.parentNode.insertBefore(reasons, reviewsWrap);

  var reviewHeading = document.querySelector('.reviews-head h2');
  if (reviewHeading) reviewHeading.textContent = 'Why buyers felt confident.';
  var reviewIntro = document.querySelector('.reviews-head p');
  if (reviewIntro) reviewIntro.textContent = 'Three direct answers on fit, specifications and material.';

  document.querySelectorAll('a[href="#proof"]').forEach(function (link) {
    if (link.getAttribute('href') === '#proof') link.href = '#why-bcf';
  });
  document.querySelectorAll('a[href="#grid"]').forEach(function (link) {
    link.href = '#minimal-brand';
  });

  // /#grid is the stable storefront route used by the hamburger menu and
  // empty-cart Continue Shopping. The old Liquid grid remains in the DOM but
  // is intentionally hidden in the minimal flow, so resolve that route to the
  // visible four-SKU rail after it has been inserted.
  if (window.location.hash === '#grid') {
    window.requestAnimationFrame(function () {
      hero.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  }
  document.dispatchEvent(new CustomEvent('bcf:minimal-home-ready'));
})();
